
// Sets an attribute and value into an element
// NOTE: this function WILL replace the value, 
// for classes use setClassIfVisible instead to account for multiple classes
// attrName defines the attribute being changed, from styles it just supports "backgroundImage"
// EXPECTS THE FOLLOWING FORMAT:
/* <div class="has-equalizer" data-equalize="child,another-child">
    <div class="child"></div>
    <p class="child"></p>
    <div>
      <ul class="another-child">
        <li>a</li>
        <li>b</li>
        <li>c</li>
      </ul>
    </div>
  </div>
*/
// EXPECTS CSS
/* 
  @media only screen and (max-width: 767px) {
    .is-equalized{
      min-height: 1px !important;
    }
  }
*/

const equalizer = function (itms) {
  itms.map(e => {
    if (e.dataset.equalize) {
      const wrappers = e.dataset.equalize.split(' ').join('').split(",");
      wrappers.map(w => {
        if (e.querySelector("." + w)) equalizeChildren(e, w);
      });
    }
  });
}

const equalizeChildren = function (prnt, wrapperName) {
  const chldrn = Array.from(prnt.querySelectorAll("." + wrapperName));
  let minHeight = 1;

  chldrn.map(e => {
    const h = e.clientHeight;
    if (h > minHeight) minHeight = h;
  });

  chldrn.map(e => {
    e.style.minHeight = minHeight + "px";
    e.classList.add("is-equalized");
  });
}

document.addEventListener('DOMContentLoaded', (e) => {
  if (document.querySelector(".has-equalizer")) equalizer(Array.from(document.querySelectorAll(".has-equalizer")));
});